import { formatMonth, fromMonthInputValue } from "../time/index.js";
/**
 * **عنوانُ بندِ «اللي عليك» كما يُقرأ** — والشهرُ باسمه.
 *
 * فبنودُ التقارير وطلباتِ الاستثناء عنوانُها **شهرُها**، ويصل من السيرفر مفتاحاً
 * («2026-09») — وكان يُعرَض كذلك في «اللي عليك» وفي الرئيسية. فيُقرأ هنا بمنسّق
 * الشهر الواحد: «سبتمبر 2026». وما ليس شهراً يُعرَض كما هو.
 */
export function actionSubject(subject, locale) {
    const month = fromMonthInputValue(subject);
    return month === null ? subject : formatMonth(month, locale);
}
//# sourceMappingURL=subject.js.map